

$(document).off('click', '#mobile-add-another-dog').on('click', '#mobile-add-another-dog', function() {
  $(".product-form__submit.button:visible").attr("add-another-dog", "true").trigger("click");
  $(".product-form__submit.button:visible").trigger("click");

  
  if ($('.dog-name').length && !$('.dog-name').val()) {
    $('html, body').scrollTop($('.dog-name').offset().top); 
  }
});

$(document).off('click', '#mobile-continue-next-step').on('click', '#mobile-continue-next-step', function() {
  $(".product-meal-plan-right.active-meal_form .product-form__submit").eq(0).click();

  
  if ($('.dog-name').length && !$('.dog-name').val()) {
    $('html, body').scrollTop($('.dog-name').offset().top); 
  }
});
